import * as React from 'react';
import Svg, { Circle, Line } from 'react-native-svg';
import type { NumberProp } from 'react-native-svg/src/lib/extract/types';

export default function FancySeparator({ width = 302, height = 11 }: { width?: NumberProp; height?: NumberProp }) {
  return (
    <Svg fill="none" height={height} viewBox="0 0 302 11" width={width}>
      <Line stroke="#DDDACF" x1="3" x2="299" y1="5.5" y2="5.5" />
      <Circle cx="299" cy="3" r="2.5" stroke="#DDDACF" />
      <Circle cx="3" cy="3" r="2.5" stroke="#DDDACF" />
      <Circle cx="299" cy="8" r="2.5" stroke="#DDDACF" />
      <Circle cx="3" cy="8" r="2.5" stroke="#DDDACF" />
    </Svg>
  );
}
